import React from "react";
import BrandedResetPassword from "@/pages/branded/BrandedResetPassword";

const BRAND = {
  name: "Management USA NJ",
  tagline: "Worker portal",
  apiPrefix: "/worker",
  loginPath: "/managementusa",
};

export default function WorkerResetPassword() {
  return <BrandedResetPassword brand={BRAND} testidPrefix="worker-reset" />;
}
